/**
 * Detects HTML produced by the Quill WYSIWYG editor (Edit Analysis flow).
 * AI-saved analyses are markdown and should render via MarkdownText instead.
 */
export function isQuillHtmlDescription(content: string): boolean {
  const trimmed = content.trim();

  if (!trimmed) {
    return false;
  }

  return /class=["'][^"']*\bql-(?:align|indent|syntax|direction|size|font|color|background)\b|<p[^>]*class=["'][^"']*\bql-/i.test(
    trimmed
  );
}
